export default __webpack_public_path__ + "static/media/image.0943bae3.png";